import React, { useEffect, useState } from "react";
import { HotmartButton } from "./common";
import { PRICE } from "@/lib/site";

export const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const nearBottom = scrolled > docHeight - 700;
      setVisible(scrolled > window.innerHeight * 0.6 && !nearBottom);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta-bar"
      className={`fixed inset-x-0 bottom-0 z-50 border-t border-[hsl(var(--border))] bg-white/95 backdrop-blur transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <div className="leading-tight">
          <p className="text-xs text-muted-foreground line-through">${PRICE.normal} MXN</p>
          <p className="font-heading text-lg font-extrabold text-[hsl(var(--brand-coral))]">
            ${PRICE.offer} MXN
          </p>
        </div>
        <HotmartButton testId="sticky-mobile-cta-button" className="h-12 flex-1 px-4 text-sm">
          Quiero el ebook
        </HotmartButton>
      </div>
    </div>
  );
};
